import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Toast } from '@gem/popups';
import { Loader } from '@gem/ui-kit';

import Entities from 'STORE';

import styles from './OfflineToast.styles.m.css';

export const OfflineToast: FC = observer(() => {
  const { t } = useTranslation();

  if (!Entities.App.isOfflineNetworkStatus) {
    return null;
  }

  // styles.container, styles.lowPriorityToast нужно для увеличения специфичности селектора, чтобы перекрыть родительские стили
  // TODO: поэкспериментировать с конфигом вебпака. Сейчас MiniCssExtractPlugin в произвольном порядке собирает
  // итоговый css бандл в один файл и порядок декларации стилей никак не задать. Получается что стили компонента объявляются позже, чем их
  // перебитие в проекте, поэтому не срабатывает стилизация без повышения специфичности.
  // есть вариант через optimizations разделить css на два файла main и файл со стилями пэкэджей и через html плагин порядок импортов
  // chunks: ['vendors', [СТИЛИ_ПАКЕТОВ], 'main'], решение рабочее, но создает много варнингов о непредсказуемом порядке ипортов - нужно будет исследовать
  const containerClassName = classNames(styles.container, styles.lowPriorityToast);

  return (
    <Toast
      className={containerClassName}
      isVisible={true}
    >
      <span className={styles.wrapper}>
        <Loader className={styles.loader} />
        {t('common_no_internet')}
      </span>
    </Toast>
  );
});
